import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import FaIcon from '../components/FaIcon'



export default class NotFound extends Component {

    render() {
		
        return (
            <div className="message" style={{ marginTop: "45px" }}>
                <FaIcon icon="map-signs" size="8x" />
                <br />
                <span style={{ fontSize: "35px" }}><FormattedMessage id="notFound.title" /></span>
                <br /><br />
                <FormattedMessage id="notFound.description" />
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/views/NotFound.js